var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "top-menu" },
    [
      _c(
        "el-menu",
        {
          attrs: {
            "default-active": _vm.activeIndex,
            mode: "horizontal",
            "active-text-color": "#5b93fc",
          },
        },
        [
          _c(
            "el-menu-item",
            {
              key: "0",
              attrs: { index: "0" },
              nativeOn: {
                click: function ($event) {
                  return _vm.openHome(_vm.itemHome)
                },
              },
            },
            [
              _c("template", { slot: "title" }, [
                _c("i", { class: _vm.itemHome.source }),
                _c("span", [_vm._v(_vm._s(_vm.generateTitle(_vm.itemHome)))]),
              ]),
            ],
            2
          ),
          _vm._l(_vm.items, function (item, index) {
            return [
              _c(
                "el-menu-item",
                {
                  key: index,
                  attrs: { index: item.id + "" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.openMenu(item)
                    },
                  },
                },
                [
                  _c("template", { slot: "title" }, [
                    _c("i", {
                      class: item.source,
                      staticStyle: { "padding-right": "5px" },
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.generateTitle(item)))]),
                  ]),
                ],
                2
              ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }